import React, { useState, Fragment, useEffect } from "react";
import Moveable from "react-moveable";
import EquipGenSymbol from "./equip-gen-symbol";

const RenderPreviewSymbol = (props: {
  feature: any;
  map: any;
  event: any;
  setevent: Function;
}) => {
  const [frame, setFrame] = useState({
    rotate: props.feature.properties?.iconRotate
      ? Number(props.feature.properties?.iconRotate)
      : 0,
  });
  const [refElement, setrefElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setrefElement(document.getElementById("preview-symbol"));
    return () => {
      setrefElement(null);
    };
  }, []);

  return (
    <Fragment>
      <div
        id="preview-symbol"
        style={{
          transform: `rotate(${frame.rotate}deg)`,
          position: "relative",
        }}
      >
        <EquipGenSymbol property={props.feature.properties} />
      </div>
      <Moveable
        target={refElement}
        rotatable={true}
        throttleRotate={0}
        rotationPosition={"top"}
        zoom={1}
        origin={false}
        padding={{ left: 0, top: 0, right: 0, bottom: 0 }}
        onRotateStart={({ set }) => {
          const initialRotate = props.feature.properties?.iconRotate
            ? Number(props.feature.properties?.iconRotate)
            : frame.rotate;
          set(initialRotate);
          setFrame({ rotate: initialRotate });
        }}
        onRotate={(e: any) => {
          setFrame({ rotate: Number(e.beforeRotate) });
        }}
        onRotateEnd={(e: any) => {
          let mapEvent = props.map;
          const draw = mapEvent._controls.find((control: any) => control.modes);
          props.setevent({
            ...props.event,
            feature: {
              ...props.feature,
              properties: {
                ...props.feature?.properties,
                iconRotate: Number(e.lastEvent.rotate),
              },
            },
          });
          draw.setFeatureProperty(
            props.feature?.id,
            "iconRotate",
            Number(e.lastEvent.rotate)
          );
        }}
      />
    </Fragment>
  );
};

export default RenderPreviewSymbol;
